import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";

export interface ActivatableCompProps {
  isActive: boolean;
}

export interface ShowHideProps {
  show: boolean;
}

export const BusinessInfo = styled.section``;

export const InfoDropDown = styled.h4`
  height: 18px;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  color: #d4d4d4;
  margin: 25px 0 9px 0;
`;

export const InfoDropDownIcon = styled.img<ActivatableCompProps>`
  width: 18px;
  height: 18px;
  transform: ${(props) => (props.isActive ? "rotate(180deg)" : "rotate(0deg)")};
  cursor: pointer;
  ${DESKTOP} {
    display: none;
  }
`;

export const InfoDetail = styled.dl<ShowHideProps>`
  font-size: 12px;
  color: #8b8b8b;
  line-height: normal;
  display: ${(props) => (props.show ? "block" : "none")};

  ${DESKTOP} {
    display: block;
    width: 665px;
    white-space: normal;
  }
`;

export const InfoDetailLine = styled.div`
  display: flex;

  ${DESKTOP} {
    display: inline-flex;
  }
`;

export const InfoDetailLineTitle = styled.dt``;

export const InfoDetailLineValue = styled.dd`
  padding-left: 3px;
`;

export const InfoDetailLink = styled.a`
  font-size: 12px;
`;

export const InfoDetailAfterLine = styled.div`
  display: none;

  ${DESKTOP} {
    display: inline-flex;
    vertical-align: middle;
    height: 10px;
    margin: 0 4px 0 7px;
    border-right: 1px solid #8b8b8b;
  }
`;
